import { parseISO, isAfter } from 'date-fns';

import { Ticket } from '../../types/ticket';
import { Rule } from '../types/Rule';
import { RuleContext } from '../types/RuleContext';

export class CheckIfGroupIsFinishedRule implements Rule {
  apply(context: RuleContext): Ticket[] {
    const { tickets } = context;

    return tickets.map(({ type }, index, reference) => (
      {
        ...reference[index],
        finished : type.every(({ endSales }) => isAfter(new Date(), parseISO(endSales)))
      }
    ));
  }
}
